import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_MY_INFO_CONSENT_FORM_URL } from '../../constants/apiUrls';
import { GET_MY_INFO_CONSENT_FORM_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

interface MyInfoConsentFormRequest {
  presignedUrl: string;
}

interface Input {
  onSuccess?: (res: MyInfoConsentFormRequest) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useGetMyInfoConsentForm = ({ onError, onSuccess }: Input = {}) => {
  const getMyInfoConsentForm = async () => {
    const res = await axiosClient.get<MyInfoConsentFormRequest>(GET_MY_INFO_CONSENT_FORM_URL);

    return res.data;
  };

  return useCustomQuery(GET_MY_INFO_CONSENT_FORM_QUERY_KEY, getMyInfoConsentForm, {
    onSuccess,
    onError,
    enabled: false,
  });
};
